import useParentSize from "../hooks/useParentSize.js";
import { jsx as _jsx } from "react/jsx-runtime";
const defaultOuterStyles = {
  width: '100%',
  height: '100%',
  position: 'relative'
};
const measurementStyles = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  overflow: 'hidden'
};
export default function ParentSize(_ref) {
  let {
    className,
    children,
    debounceTime,
    ignoreDimensions,
    initialSize,
    parentSizeStyles,
    enableDebounceLeadingCall = true,
    resizeObserverPolyfill,
    style,
    ...restProps
  } = _ref;
  const {
    parentRef,
    node,
    resize,
    ...dimensions
  } = useParentSize({
    initialSize,
    debounceTime,
    ignoreDimensions,
    enableDebounceLeadingCall,
    resizeObserverPolyfill
  });
  const outerStyle = parentSizeStyles ? {
    position: 'relative',
    ...parentSizeStyles,
    ...style
  } : {
    ...defaultOuterStyles,
    ...style
  };
  return /*#__PURE__*/_jsx("div", {
    style: outerStyle,
    className: className,
    ...restProps,
    children: /*#__PURE__*/_jsx("div", {
      style: measurementStyles,
      ref: parentRef,
      children: children({
        ...dimensions,
        ref: node,
        resize
      })
    })
  });
}